@if (vm.confirmedBookingLoaded) {
  <div id="page-root" class="max-w-760">
    <section class="header">
      <section class="icon-wrapper">
        <i class="fa-light fa-circle-check"></i>
        <h1 class="heading-1">Thanks for booking</h1>
      </section>
      <p class="body mt-8">
        We’ve emailed you these details. You can also
        <a class="body bold large" (click)="handleDownload()">download a copy.</a>
      </p>
    </section>

    <section class="booking mt-32 sm-mt-24 mb-64 sm-mb-40">
      <section class="flex container">
        <section class="flex-col min-w-300">
          <div class="block-wrapper">
            <h2 class="heading-5">Your booking</h2>
            @for (items of bookingSummaryItems; track items.label) {
              <p class="body bold mt-12">{{ items.label }}</p>
              <p class="body mt-4" [attr.data-testid]="items.testId">{{ items.value }}</p>
            }
            <div class="divider mt-16 mb-16"></div>

            <app-vulnerable-customers> </app-vulnerable-customers>
          </div>

          <div class="block-wrapper">
            <h2 class="heading-5">Who'll repair it</h2>

            <p class="body bold mt-12">Repairer</p>
            <p class="body mt-4" data-testid="repairer-name">{{ vm.formattedRepairerName }}</p>

            <p class="body bold mt-12">Email</p>
            <section class="email-link">
              <i class="fa-light fa-envelope"></i>
              <a [href]="'mailto:' + vm.serviceProvider.emailAddress" class="link-text" data-testid="repairer-email">
                {{ vm.serviceProvider.emailAddress }}
              </a>
            </section>

            <p class="body bold mt-12">Phone</p>
            <app-telephone-link
              [phoneNumber]="vm.serviceProvider?.phoneNos?.[0]?.number"
              data-testid="repairer-phone"
              class="mt-4"
            />

            <div class="divider mt-24 mb-24 md-mt-16 md-mb-16"></div>

            <app-contact-hours [contactHours]="vm.serviceProvider.openingHours" />
          </div>
        </section>

        <section class="flex-col col-2 min-w-300">
          <div class="block-wrapper">
            <h2 class="heading-5">Stay up to date</h2>
            <p class="body mt-8">You can check when your engineer will arrive and change your details.</p>
            <app-button
              dataLabel="mmr-button"
              class="md-ml-0 sm-full-width sm-mt-8 mt-16"
              [buttonOptions]="{
                variant: 'secondary',
                isLink: true,
                url: vm.mmrLink,
              }"
              (onClick)="clearConfirmedBooking()"
            >
              Manage my repair
              <i class="fa-light fa-arrow-right ml-8"></i>
            </app-button>
          </div>
          <div class="block-wrapper">
            <h2 class="heading-5">What happens next?</h2>

            <p class="body bold mt-12">
              <i class="fa-light fa-truck fa-lg mr-8" style="color: #8b56e7"></i>Arrange parking
            </p>
            <p class="body mt-4">Remember to have a parking permit ready on the day.</p>

            <p class="body bold mt-12">
              <i class="fa-light fa-universal-access fa-lg mr-8" style="color: #09788c"></i>Provide access
            </p>
            <p class="body mt-4">
              Before the repair, unplug your appliance and make it easy to reach. (Also defrost it, if it's a freezer.)
            </p>

            <p class="body bold mt-12">
              <i class="fa-light fa-envelope fa-lg mr-8" style="color: #ce7e07"></i>Repair updates
            </p>
            <p class="body mt-4">You’ll get a booking confirmation by email, and text reminders before the repair.</p>
          </div>
          <div class="block-wrapper">
            <h2 class="heading-5">Your contact details</h2>

            <p class="body bold mt-12">Address</p>
            <section class="flex-col mt-4 address">
              @for (line of vm.address; track line; let i = $index) {
                <p class="body" [attr.data-testid]="'customer-address-' + i">{{ line }}</p>
              }
            </section>

            @if (vm.contact.phonePrimary) {
              <p class="body bold mt-12">Phone</p>
              <p class="body mt-4" data-testid="customer-phone">{{ vm.phoneNumber }}</p>
            }

            @if (vm.contact.email) {
              <p class="body bold mt-12">Email</p>
              <p class="body mt-4" data-testid="customer-email">{{ vm.contact.email }}</p>
            }
          </div>
        </section>
      </section>
    </section>
  </div>
}

<section style="position: absolute; top: 0; left: 0; z-index: -1" id="copy-content"></section>
